const DESKTOP_VERTICAL_PADDING = '$spacing.xl' as const;
const MOBILE_VERTICAL_PADDING = '$spacing.md' as const;

const HORIZONTAL_PADDING = '$spacing.md' as const;

const MOBILE_BREAKPOINT = '@media $lg_lte' as const;

export const CONTAINER_SX = {
    width: '$breakpoints.xxl',
    maxWidth: '100%',
    overflow: 'hidden',
    padding: `${DESKTOP_VERTICAL_PADDING} ${HORIZONTAL_PADDING}`,
    margin: '0 auto',
    [MOBILE_BREAKPOINT]: {
        padding: MOBILE_VERTICAL_PADDING,
    },
} as const;
